import React, { useEffect, useState } from "react";
import './projecttab.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ProjectTab = ({ catogory }) => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  
  const postsPerPage = 9;

  // Replace this with the actual API category ID if needed
  const getApiUrl = (page = 1) => {
    return `https://cms.gammadda.lk/wp-json/wp/v2/posts?categories=${catogory}&per_page=${postsPerPage}&page=${page}&_embed`;
  };

  // Hardcoded map of category ID => category name
  const categoryMap = {
    7: 'infrastructure',
    11: 'education',
    14: 'welfare',
    12: 'water, sanitation & hygiene',
  };

  // Get category name from post's category ID list
  const getCategoryClass = (post) => {
    const categoryIds = post.categories || [];
    for (let id of categoryIds) {
      if (categoryMap[id]) return categoryMap[id];
    }
    return 'uncategorized';
  };

  // Filter categories for buttons
  const categories = ['all', 'infrastructure', 'education', 'welfare', 'water, sanitation & hygiene'];

  const fetchProjects = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(getApiUrl(page));
      const data = await response.json();
      
      // Get total pages from response headers
      const totalPages = parseInt(response.headers.get('X-WP-TotalPages')) || 1;
      
      setProjects(data);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(currentPage);
  }, [catogory, currentPage]);

  // Reset to page 1 when filter changes
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [filter]);

  const getImageUrl = (post) => {
    if (post._embedded && post._embedded["wp:featuredmedia"] && post._embedded["wp:featuredmedia"][0]) {
      return post._embedded["wp:featuredmedia"][0].source_url;
    }
    return "default-image.jpg";
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    const paginationButtonStyle = {
      color: '#f94322',
      borderColor: '#000000',
      backgroundColor: 'transparent'
    };

    const activeButtonStyle = {
      color: 'white',
      backgroundColor: '#f94322',
      borderColor: '#000000'
    };

    const disabledButtonStyle = {
      color: '#6c787d',
      backgroundColor: 'transparent',
      borderColor: '#000000'
    };

    return (
      <nav aria-label="Projects pagination" className="d-flex justify-content-center mt-4">
        <ul className="pagination">
          {/* Previous button */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={currentPage === 1 ? disabledButtonStyle : paginationButtonStyle}
            >
              Previous
            </button>
          </li>

          {/* First page if not visible */}
          {startPage > 1 && (
            <>
              <li className="page-item">
                <button 
                  className="page-link" 
                  onClick={() => handlePageChange(1)}
                  style={paginationButtonStyle}
                >
                  1
                </button>
              </li>
              {startPage > 2 && (
                <li className="page-item disabled">
                  <span className="page-link" style={disabledButtonStyle}>...</span>
                </li>
              )}
            </>
          )}

          {/* Page numbers */}
          {pageNumbers.map((page) => (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
                style={currentPage === page ? activeButtonStyle : paginationButtonStyle}
              >
                {page}
              </button>
            </li>
          ))}

          {/* Last page if not visible */}
          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && (
                <li className="page-item disabled">
                  <span className="page-link" style={disabledButtonStyle}>...</span>
                </li>
              )}
              <li className="page-item">
                <button 
                  className="page-link" 
                  onClick={() => handlePageChange(totalPages)}
                  style={paginationButtonStyle}
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}

          {/* Next button */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={currentPage === totalPages ? disabledButtonStyle : paginationButtonStyle}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  // Filter projects based on current filter
  const filteredProjects = projects.filter((post) => {
    const category = getCategoryClass(post);
    return filter === 'all' || category === filter;
  });

  return (
    <div className="container">
      {/* Filter Buttons */}
      <div className="text-center mt-3" style={{ marginBottom: '30px' }}>
        {categories.map((cat) => (
          <button
            key={cat}
            className={`btn btn-default filter-button ${filter === cat ? 'active' : ''}`}
            onClick={() => setFilter(cat)}
          >
            {cat === 'all' ? 'All' : cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="container" style={{ maxWidth: '960px' }}>
        <div className="row">
          {loading ? (
            <div className="col-12 text-center">
              <p>Loading projects...</p>
            </div>
          ) : filteredProjects.length > 0 ? (
            filteredProjects.map((post) => {
              const { funded, totalrequiredfund } = post.acf || {};
              const fundedAmount = parseFloat(funded) || 0;
              const totalRequired = parseFloat(totalrequiredfund) || 1;
              const progress = Math.min((fundedAmount / totalRequired) * 100, 100);

              return (
                <div className="col-md-4 col-sm-6 col-12 mb-3" key={post.id}>
                  <div className="card card-latest">
                    <img
                      src={getImageUrl(post)}
                      className="card-img-top"
                      alt={post.title.rendered}
                    />
                    <div className="card-body text-center">
                      <h5 className="card-title">
                        {post.title.rendered.replace(/&#038;/g, '&')}
                      </h5>
                      <a
                        href={`/projects/${post.slug}`}
                        className="gm---heading-3"
                        style={{ textDecoration: "none", color: "#f94322" }}
                      >
                        View Project
                      </a>
                    </div>
                    <div className="progressbarsmall">
                      <div
                        className="progress"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12 text-center">
              <p>No projects found for the selected category.</p>
            </div>
          )}
        </div>
      </div>

      {/* Pagination */}
      {renderPagination()}
    </div>
  );
};

export default ProjectTab;